<template>
    <section class="panel panel-featured-left panel-featured-primary">
        <div class="panel-body">
            <div class="widget-summary">
                <div class="widget-summary-col widget-summary-col-icon">
                    <div class="summary-icon bg-primary">
                        <i class="fa fa-file"></i>
                    </div>
                </div>
                <div class="widget-summary-col">
                    <div class="summary">
                        <h4 class="title">Última Factura </h4>
                        <div v-if="isLoading || typeof(lastInvoice) === 'undefined'">
                            <img src="/assets/images/loading.gif" alt="loading..." />
                        </div>
                        <div v-else>
                            Numero: {{ lastInvoice.invoiceNumber }} <br/>
                            Total: {{ lastInvoice.totalAmount }}
                        </div>
                    </div>
                    <div class="summary-footer">
                        <router-link to="/features/invoices" class="text-muted text-uppercase">
                            (ver todas las facturas)
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>   
</template>

<script>
    module.exports = {
        name: 'app',
        data: function () {
            return {
                lastInvoice : null,
                isLoading : true               
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        methods: {
            async refresh() {
                var self = this;
                this.isLoading = true;
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "invoices/last",
                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        //console.debug(response.data);
                        self.lastInvoice = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>